/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Token_Pasted_ToastInputs */



/**
* | output |
* | --- |
* | "Live captioning token pasted." |
*
* @param {Live_Caption_Token_Pasted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_token_pasted_toast = /** @type {((inputs?: Live_Caption_Token_Pasted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Token_Pasted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Jeton de sous-titrage en direct collé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Untertitelungstoken eingefügt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Token per la sottotitolazione in tempo reale incollato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Токен для субтитров в реальном времени вставлен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se ha pegado el token de subtítulos en directo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已粘贴实时字幕令牌。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブキャプショントークンが貼り付けられました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग टोकन पेस्ट किया गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Token de legendagem ao vivo colado.")
	return /** @type {LocalizedString} */ ("Live captioning token pasted.")
});